<template>
    <input
        :class="'form-control hasDatepicker'+iconClass"
        type="text"
        :placeholder="placeholder"
        :data-title="title"
        :name="name"
        :value="date"
        autocomplete="off"
        @change="setDate($event.target.value)"
        :required="required"
        ref="input" />
</template>

<script>
export default {
    props: {
        placeholder: String,
        title: String,
        name: String,
        minDate: String,
        maxDate: String,
        icon: String,
        value: String,
        availableDates: Array,
        required: {
            type: Boolean,
            default: false,
        }
    },
    data() {
        return {
            input: null,
            shown: false,
        }
    },
    computed: {
        iconClass() {
            return this.icon ? ' has-icon has-icon-'+this.icon : ''
        },
        date() {
            return this.value ? moment(this.value).format('DD/MM/YYYY') : ''
        }
    },
    mounted() {
        this.initialize()
    },
    watch: {
        value(value) {
            this.input.datepicker('setDate', this.date)
        },
        minDate() {
            this.input.datepicker('setStartDate', this.minDate)
        },
        maxDate() {
            this.input.datepicker('setEndDate', this.maxDate)
        },
        availableDates() {
            this.input.datepicker('update', '')
            //this.destroy()
            //this.initialize()
        }
    },
    beforeUnmount() {
        this.destroy()
    },
    methods: {
        setDate(newValue) {
            this.input.datepicker('setDate', newValue)
        },
        show() {
            this.input.datepicker('show')
        },
        destroy() {
            this.input.off().datepicker('destroy');
        },
        initialize() {
            let that = this
            this.input = $(this.$el).datepicker({
                format: 'dd/mm/yyyy',
                autoclose: true,
                todayHighlight: false,
                startDate: this.minDate ? this.minDate : new Date(),
                endDate: this.maxDate ? this.maxDate : '',
                orientation: 'bottom',
                beforeShowDay: function(date) {
                    return (that.availableDates === undefined || that.availableDates.includes(moment(date).format('YYYY-MM-DD')))
                }
            }).on('show', function () {
                //$('.datepicker-title', this).html(that.title).show();
                this.shown || that.$emit('show')
                this.shown = true
            }).on('hide', function () {
                this.shown = false
            }).on('changeDate', function(e) {
                that.$emit('input', moment(e.date).format('YYYY-MM-DD'))
            })
        }
    }
}
</script>

<style scoped>
input {
    background-color: #fff !important;
}
</style>